import { Expose, Transform, TransformPlainToClass } from 'class-transformer';

import { ExposeFunction } from '@lib/common/decorators';
import { SnRoute } from '@lib/state/router';
import { SnBadge } from '@lib/ui/badge';
import { SnIcon } from '@lib/ui/icon';

import {
  SnMenuItemConfig,
  SnMenuItemClickHandler,
  SnMenuItemHideExpression,
  SnMenuItemDisableExpression,
} from '../types';

export class SnMenuItem<D = any> {
  @Expose()
  public readonly label: string;

  @Expose()
  @Transform((value, data) => SnIcon.fromConfig(data.icon))
  public readonly icon: SnIcon;

  @Expose()
  @Transform((value, data) => SnBadge.fromConfig(data.badge))
  public readonly badge: SnBadge;

  @Expose()
  @Transform((value, data) => SnRoute.fromConfig(data.route))
  public readonly route: SnRoute;

  @ExposeFunction()
  public readonly click: SnMenuItemClickHandler<D>;

  @ExposeFunction()
  public readonly hidden: SnMenuItemHideExpression<D>;

  @ExposeFunction()
  public readonly disabled: SnMenuItemDisableExpression<D>;

  @TransformPlainToClass(SnMenuItem, { strategy: 'excludeAll' })
  public static fromConfig(config: SnMenuItemConfig): SnMenuItem {
    return config as SnMenuItem;
  }

  constructor() {}
}
